<template>
  <div>
    <sectionHeading text="ISRT Alpha Solutions" />
    <p>
      Mathematics being a compulsory subject of study, access to quality
      mathematics education is every child's right. On the other hand,
      mathematics education in our schools is beset with problems. Due to the
      hierarchy of concepts and largely deductive and abstract nature of the
      subject, mathematics is considered as a very dull and difficult subject. A
      phobia has been created in the minds of the children that mathematics is
      tough to learn. As a result, most of the students are not taking interest
      in the subject and it has become one of the main cause of student's
      failure in mathematics
    </p>
    <p>
      A shift in focus is needed in mathematical teaching especially in
      mathematical learning environment, where whole ranges of process take
      precedence: Formal problem solving, Use of heuristics, Estimation and
      Approximation, Optimization and Mathematical Communication.
    </p>
    <img src="@/assets/img/sampleCropped.jpeg" />
    <p>
      Mathematics being a compulsory subject of study, access to quality
      mathematics education is every child's right. On the other hand,
      mathematics education in our schools is beset with problems. Due to the
      hierarchy of concepts and largely deductive and abstract nature of the
      subject, mathematics is considered as a very dull and difficult subject. A
      phobia has been created in the minds of the children that mathematics is
      tough to learn. As a result, most of the students are not taking interest
      in the subject and it has become one of the main cause of student's
      failure in mathematics
    </p>
    <p>
      A shift in focus is needed in mathematical teaching especially in
      mathematical learning environment, where whole ranges of process take
      precedence: Formal problem solving, Use of heuristics, Estimation and
      Approximation, Optimization and Mathematical Communication.
    </p>
  </div>
</template>

<script>
export default {
  name: "thirdSection"
};
</script>
<style lang="scss" scoped>
img {
  width: 100%;
}
</style>

